import React, { useState, useEffect } from 'react';
// Components
import Icon from '../Icon/Icon.jsx';
import Header from '../Header/Header.jsx';
// Styles
import './Dialog.css';

const NAME = 'io-dialog';
const Dialog = ({
    children,
    title,
    onClose,
    wide,
    isOpen, 
    directControl,
    className,
    hideCloseButton
}) => {
    const [isActive, setIsActive] = useState(isOpen);
    
    const handleOnClose = () => {
        if (onClose) {
            onClose();
        }
        
        if (directControl) {
            return;
        }
        else {
            document.body.style.overflow = 'scroll';
            setIsActive(false);            
        }
    }
    
    useEffect(() => {
        if (directControl) {
            return;
        }
        
        if (isActive) {
            document.body.style.overflow = 'hidden';
        }
        // Specify how to clean up after this effect:
        return function cleanup() {
            document.body.style.overflow = 'scroll';
        };
    });
    
    // the old way do not allow to reopen the dialog
    // directControl will use  isOpen prop to contorl the 
    var show = undefined;
    if (directControl) {
        show = isOpen;
    }
    else {
        show = isActive;
    }

    return (
        <div className={`${NAME}-container ${show ? 'io-dialog-show' : 'io-dialog-hide'} ${wide ? 'full-bleed' : 'narrow'} ${className}`}>
            <div className="io-dialog-backdrop"></div>
            <div className={`${NAME}-body ${wide ? 'full-bleed' : 'narrow'}`}>
                {! hideCloseButton &&
                    <Icon onClick={handleOnClose} name="close" color="#525252" size={24} className={`${NAME}-close-icon ${wide ? 'full-bleed' : 'narrow'}`} />
                }
                {title &&
                    <Header color="#525252" As="h1">{title}</Header>
                }
                {content &&
                    <div className={`${NAME}-content ${wide ? 'full-bleed' : 'narrow'}`}>
                        {children}
                    </div>
                }
            </div>
        </div>
    );
};

export default Dialog;
